import { OptionsApi } from '@core/swagger-client';
import { ErrorMessagePage, LoaderPage } from '@core/ui';
import { useLocation, useNavigate, useParams } from '@online-webinar/router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useAuthRedirect } from '../../../hooks/useAuthRedirect';
import { AccountWizardState } from '../../../types';
import { AuthPageTitle } from '../../atoms';
import { RegisterForBroadcastInfo } from '../../molecules';
import { AuthPage, AuthPageContent, Register, RegisterSideContent } from '../../organism';

export const RegisterPage = () => {
    const { webinarId } = useParams({ strict: false });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    useAuthRedirect();

    const emailAddress = (location.state?.wizard as AccountWizardState | undefined)?.emailAddress ?? undefined;

    const { isLoading, data: webinar, error } = useQuery(OptionsApi.webinar.get(webinarId!, { enabled: !!webinarId, staleTime: 60_000 }));

    const onBack = () => {
        if (webinarId) {
            navigate({ to: '/$webinarId/login', params: { webinarId }, state: location.state });
        } else {
            navigate({ to: '/login', state: location.state });
        }
    };

    if (error) return <ErrorMessagePage apiError={error} />;
    if (isLoading) return <LoaderPage />;

    return (
        <AuthPage>
            <AuthPageContent>
                {webinar && <RegisterForBroadcastInfo webinar={webinar} />}
                <AuthPageTitle className="mb-8">{t('Pages.Register.Header')}</AuthPageTitle>
                <Register emailAddress={emailAddress} quickRegister={!!webinarId} onBack={onBack} />
            </AuthPageContent>
            <RegisterSideContent />
        </AuthPage>
    );
};
